<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container px-6">
		<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
			<floating-buttons
				:titleHeader="$t('BreakTable.Action')"
				:cancelText="$t('MODULE_PERMISSION.Cancel')"
				:disabledSave="!validateForm"
				:saveText="$t('Save')"
				@save="save_changes"
				@cancel="$router.push({name: 'app-vehicle-list'})"
			/>
		</div>
		<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
			<vs-tab :label="$t('Information')" icon-pack="feather" icon="icon-user">
				<div class="tab-text">
					<div id="user-edit-tab-info">
						<vx-card :cardBorder="true" :noShadow="true" :title="$t('GeneralInformation')">
							<div class="vx-row">
								<div class="vx-col md:w-2/3 sm:w-2/3 w-full">
									<form>
										<div class="vx-row">
											<!--IDENTIFICATION -->
											<div class="vx-col w-full">
												<vs-input
													class="w-full"
													v-model="vehicle.identification"
													v-validate="'required'"
													name="identification"
													:label="$t('Routing.Table.Identification')"
													:danger="dangerInput.identification.show"
													:danger-text="dangerInput.identification.text"
													@focus="() => (dangerInput.identification.show = false)"
												/>
												<span
													class="text-danger text-sm"
													v-show="errors.has('identification')"
													>{{
														$t("ResourceModule.BasicInfoForm.ValidMessages.Identification")
													}}</span
												>
											</div>
										</div>
										<div class="vx-row mt-4">
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<label class="vs-input--label">{{ $t("Profile") }}</label>
												<v-select
													v-model="vehicle.profile"
													name="profile"
													:clearable="false"
													:options="profileOptions"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small class="date-label">{{
													$t("ResourceModule.Create.MaxTravelDistance") + " " + "(Mts)"
												}}</small>
												<vs-input
													v-model.trim="vehicle.max_travel_distance"
													class="w-full"
													type="text"
													:placeholder="$t('ResourceModule.Create.MaxTravelDistance')"
													:vs-placeholder="$t('ResourceModule.Create.MaxTravelDistance')"
													@keypress="validateAmountNumber"
												/>
											</div>
										</div>
										<div class="vx-row mt-4">
											<div class="vx-col w-full">
												<small class="date-label">{{
													$t("ResourceModule.Create.MaxServiceTime")
												}}</small>
												<div class="flex flex-row justify-between">
													<vs-input-number
														v-model="hours"
														class="w-1/4 mr-4 text-sm"
														:label="$t('RouterSelection.Hours')"
														:min="0"
														:max="24"
														@keypress="validateInputNumber"
														@change="validateDateHours"
													/>
													<vs-input-number
														v-model="minutes"
														class="w-full text-sm"
														:label="$t('RouterSelection.Minutes')"
														:min="0"
														:max="59"
														@keypress="validateInputNumberMinutes"
														@change="validateDateMinutes"
													/>
													<vs-input-number
														v-model="seconds"
														class="w-full ml-4 text-sm"
														:label="$t('RouterSelection.Seconds')"
														:min="0"
														:max="59"
														@keypress="validateInputNumberSeconds"
														@change="validateDateSecond"
													/>
												</div>
											</div>
										</div>
										<div class="vx-row mt-2">
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small>{{ $t("Deposits.Form.StartDeposit") }}</small>
												<vx-input-group>
													<vs-input
														name="startdeposit"
														type="text"
														class="w-full"
														v-model="vehicle.init_depot_id"
														readonly
													/>
													<template slot="append">
														<div class="append-text btn-addon">
															<vs-button
																v-if="vehicle.init_depot_id !== null"
																color="danger"
																icon-pack="feather"
																icon="icon-x"
																:title="
																	$t('Crud.Delete') + ' ' + $t('Deposits.Deposit')
																"
																@click.prevent="removeDepositInit"
															></vs-button>
															<vs-button
																color="primary"
																icon-pack="feather"
																icon="icon-plus"
																:title="$t('Add')"
																@click.prevent="showPopupDepositInit"
															></vs-button>
														</div>
													</template>
												</vx-input-group>
											</div>
											<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
												<small>{{ $t("Deposits.Form.EndDeposit") }}</small>
												<vx-input-group>
													<vs-input
														name="enddeposit"
														type="text"
														class="w-full"
														v-model="vehicle.end_depot_id"
														readonly
													/>
													<template slot="append">
														<div class="append-text btn-addon">
															<vs-button
																v-if="vehicle.end_depot_id !== null"
																color="danger"
																icon-pack="feather"
																icon="icon-x"
																:title="
																	$t('Crud.Delete') + ' ' + $t('Deposits.Deposit')
																"
																@click.prevent="removeDepositEnd"
															></vs-button>
															<vs-button
																color="primary"
																icon-pack="feather"
																icon="icon-plus"
																:title="$t('Add')"
																@click.prevent="showPopupDepositEnd"
															></vs-button>
														</div>
													</template>
												</vx-input-group>
											</div>
										</div>
										<div class="vx-row">
											<vx-card :noShadow="true" :title="$t('MODULE_SOURCE.Costs')">
												<form>
													<div class="vx-row">
														<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
															<vs-input
																class="w-full"
																v-model="vehicle.costs.fixed"
																name="identification"
																:label="$t('ResourceModule.Costs.Fixed cost')"
																@keypress="validateAmountNumber"
															/>
														</div>
														<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
															<vs-input
																class="w-full"
																v-model="vehicle.costs.distance"
																name="identification"
																:label="
																	$t(
																		'ResourceModule.Costs.Cost per kilometer of the vehicle route'
																	)
																"
																@keypress="validateAmountNumber"
															/>
														</div>
													</div>
													<div class="vx-row mt-2">
														<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
															<vs-input
																class="w-full"
																v-model="vehicle.costs.time"
																name="identification"
																:label="
																	$t(
																		'ResourceModule.Costs.Cost per hour of the vehicle route'
																	)
																"
																@keypress="validateAmountNumber"
															/>
														</div>
														<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
															<vs-input
																class="w-full"
																v-model="vehicle.costs.traveled_hour"
																name="identification"
																:label="
																	$t(
																		'ResourceModule.Costs.Cost per traveled hour of the vehicle route'
																	)
																"
																@keypress="validateAmountNumber"
															/>
														</div>
													</div>
												</form>
											</vx-card>
										</div>
										<div class="vx-row">
											<vx-card :noShadow="true" :title="$t('AdditionalFields')">
												<template slot="actions">
													<vs-button
														class="ml-2 mr-2 font-bold"
														color="primary"
														type="flat"
														icon-pack="feather"
														icon="icon-plus"
														@click.prevent="showPrompt()"
														>{{ $t("Add") }}
													</vs-button>
												</template>
												<vs-table :data="propertiesList" noDataText="">
													<template slot="thead">
														<vs-th>{{ $t("Label") }}</vs-th>
														<vs-th>{{ $t("Routing.Table.Type") }}</vs-th>
														<vs-th>{{ $t("Value") }}</vs-th>
														<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
													</template>
													<template slot-scope="{data}">
														<vs-tr :key="indextr" v-for="(tr, indextr) in data">
															<vs-td :data="data[indextr].label">{{
																data[indextr].label
															}}</vs-td>
															<vs-td :data="data[indextr].type.value">{{
																data[indextr].type.value
															}}</vs-td>
															<vs-td :data="data[indextr].value">{{
																data[indextr].value
															}}</vs-td>
															<vs-td>
																<feather-icon
																	icon="EditIcon"
																	svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
																	@click="editSelect(data[indextr], indextr)"
																/>
																<feather-icon
																	icon="Trash2Icon"
																	svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
																	@click="deleteItem(data[indextr], indextr)"
																/>
															</vs-td>
														</vs-tr>
													</template>
												</vs-table>
												<vs-prompt
													:title="$t('PropertyDefinition')"
													:active.sync="showPromptField"
													:acceptText="$t('Accept')"
													:cancelText="$t('Cancel')"
													:is-valid="validFormAdditionalFields"
													@accept="addProperty(property)"
												>
													<div class="vx-row mt-2">
														<div class="vx-col w-full mt-2">
															<small class="date-label cursor-pointer">
																{{ $t("Label") }}: ({{ $t("LabelHelp") }})
																<i
																	class="material-icons ml-1 text-center"
																	style="font-size: 14px"
																	:title="$t('AcceptsNumbersAndTheDashSign')"
																>
																	info
																</i>
															</small>
															<vs-input
																v-model.trim="property.label"
																class="w-full"
																name="label"
																:vs-placeholder="$t('Label')"
																:placeholder="$t('Label')"
																:disabled="isUpdate"
																@keypress="validateKeyAdditionalInfo"
															/>
														</div>
														<div class="vx-col w-full">
															<small class="date-label">{{
																$t("ResourceModule.Create.Type")
															}}</small>
															<v-select
																v-model="property.type"
																name="type"
																:options="type"
																:dir="$vs.rtl ? 'rtl' : 'ltr'"
																:clearable="false"
															>
																<template v-slot:no-options="{search, searching}">
																	<template v-if="searching">
																		{{ $t("NoResultsFoundFor") + " "
																		}}<em>{{ search }}</em>
																	</template>
																	<template v-else>
																		{{ $t("NoResultsFound") }}
																	</template>
																</template>
															</v-select>
														</div>
														<div class="vx-col w-full mt-2">
															<small class="date-label"
																>{{ $t("Value") }}: ({{ $t("TagValue") }})</small
															>
															<flat-pickr
																v-if="property.type.value === 'datetime'"
																class="w-full"
																v-model="property.value"
																:placeholder="$t('Select')"
																:config="configdateTimePicker"
															/>
															<vs-input
																v-else
																v-model.trim="property.value"
																class="w-full"
																:type="property.type.value"
																:placeholder="
																	property.type.value === 'date' ||
																	property.type.value === 'time'
																		? ''
																		: $t('Value')
																"
																:vs-placeholder="$t('Value')"
															/>
														</div>
													</div>
												</vs-prompt>
											</vx-card>
										</div>
									</form>
								</div>
								<div class="vx-col md:w-1/3 sm:w-1/3 w-full">
									<vx-card :cardBorder="true" :noShadow="true">
										<google-map
											v-if="showMap"
											name="map-vehicle"
											latitude="4.686699"
											longitude="-74.0837187"
											zoom="13"
											theme="uber"
											calledFrom="calendar"
											ref="moduleMap"
										></google-map>
									</vx-card>
								</div>
							</div>
						</vx-card>
						<vs-popup
							:fullscreen="false"
							:title="$t('Deposits.ListOfDeposits')"
							:active.sync="depotMounted"
							class="vs-popup--content-custom"
						>
							<depot-list
								v-if="depotMounted"
								:customConfig="depotListConfig"
								@getInfoDepot="depotSelected"
							/>
						</vs-popup>
					</div>
				</div>
			</vs-tab>
			<vs-tab
				:label="$t('VisitPoints.Add') + ' ' + $t('Capacity.Capabilities')"
				icon-pack="feather"
				icon="icon-box"
			>
				<div class="tab-text">
					<assigned-capacity-list
						:capacities="vehicle.capacities && vehicle.capacities.length > 0 ? vehicle.capacities : []"
						:is-demand="true"
						:is-type-service="false"
						:capacityListIds="capacityIds"
						:navbarOptions="true"
						:columns="columnsCapacity"
						:defaultColumns="defaultColumnsCapacity"
						:isAssignedCapacities="false"
					/>
				</div>
			</vs-tab>
			<vs-tab :label="$t('VisitPoints.Add') + ' ' + $t('Skills.Skills')" icon-pack="feather" icon="icon-award">
				<div class="tab-text">
					<assigned-skill-list
						:isAssignedSkills="false"
						:skillListIds="skillsIds"
						:customConfig="skillListConfig"
					/>
				</div>
			</vs-tab>
			<vs-tab :label="$t('VisitPoints.Add') + ' ' + $t('Teams.Teams')" icon-pack="feather" icon="icon-users">
				<div class="tab-text">
					<assigned-teams-list
						:isAssignedTeams="false"
						:teamListIds="teamsIds"
						:customConfig="teamListConfig"
					/>
				</div>
			</vs-tab>
			<vs-tab :label="$t('VisitPoints.Add') + ' ' + $t('Breaks')" icon-pack="feather" icon="icon-calendar">
				<div class="tab-text">
					<assigned-break-list :isAssignedBreaks="false" :navbarOptions="true" :breakIds="breaksIds" />
				</div>
			</vs-tab>
			<vs-tab
				:label="$t('VisitPoints.Add') + ' ' + $t('Frequency.Frequencies')"
				icon-pack="feather"
				icon="icon-radio"
			>
				<div class="tab-text">
					<assigned-frequency-list
						:isAssignedFrequencies="false"
						:navbarOptions="true"
						:frequencyIds="frequencyIds"
					/>
				</div>
			</vs-tab>
		</vs-tabs>
	</div>
</template>

<script>
import {vehicleEditMixin} from "../model/VehicleEditMixin";

export default {
	mixins: [vehicleEditMixin],
};
</script>
